export type TTimezone =
  | '12'
  | '11'
  | '10'
  | '9'
  | '8'
  | '7'
  | '6'
  | '5'
  | '4'
  | '3'
  | '2'
  | '1'
  | '0'
  | '-1'
  | '-2'
  | '-3'
  | '-4'
  | '-5'
  | '-6'
  | '-7'
  | '-8'
  | '-9'
  | '-10'
  | '-11'
  | ''
  | undefined

// 记录下抛出的错误是否有被处理（如交互上是否有提示用户），如果处理过则后续可以不用处理。
export class HandledError extends Error {
  handled: boolean = true
  constructor(message: string | Error) {
    super(message instanceof Error ? message.message : message)
  }
}

export type TBizType = 'perpetual' | 'deliver'
export type TCryptoUnitType = 'cont' | 'crypto'
export type TStableCoinType = 'usdt' | 'usdc'
export type TUnitType = TCryptoUnitType | TStableCoinType // 合约单位类型

// 交割合约类型 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季
export type TDeliverContractType = 'week' | 'nextWeek' | 'quarter' | 'nextQuarter'

// 价格类型 最新价 标记价
export type TPriceType = 'lastPrice' | 'markPrice'
